import * as estimateToOrder from './estimate-to-order';
import * as standard from './standard';

export * as estimateToOrder from './estimate-to-order';
export * as standard from './standard';

export const formIds = [...estimateToOrder.formIds, ...standard.formIds];

export const ids = [...estimateToOrder.ids, ...standard.ids];
